import { render, staticRenderFns } from "./PatientManager.vue?vue&type=template&id=2ff6c928&scoped=true&"
import script from "./PatientManager.vue?vue&type=script&lang=js&"
export * from "./PatientManager.vue?vue&type=script&lang=js&"
import style0 from "./PatientManager.vue?vue&type=style&index=0&id=2ff6c928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6c928",
  null
  
)

export default component.exports